module.exports = __webpack_public_path__ + "61de6e3476f171e0075e47bfce5d51e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructors/images/icons/twitter.svg
// module id = 30
// module chunks = 0 1